module.exports = __webpack_public_path__ + "img/ECGCABLEBANANA.3356fc2f.jpg";